module.exports = __webpack_public_path__ + "static/media/become-img-3-1.a017fda5.png";